export function getTargetOrigin() {
    var _a;
    return ((_a = window.__tbxConfig) === null || _a === void 0 ? void 0 : _a.targetOrigin) || ".testbox.com";
}
export function getLogLevel() {
    return window.__tbxConfig.logLevel || "none";
}
export function getConfigItem(key, fallback) {
    return (window.__tbxConfig ? window.__tbxConfig[key] : undefined) || fallback;
}
